// https://github.com/developit/dlv/blob/master/index.js
export default function dotProp(obj: any, key: any, def: any, p: any, undef: any) {
  key = key.split ? key.split('.') : key
  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef
  }
  return obj === undef ? def : obj
}
